export function generateDivId() {
  return (Math.random() + 1).toString(36).substring(10);
}